import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row py-4 lg:justify-end" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "inline-flex items-center rounded-full border border-transparent bg-secondary-200 p-2 leading-normal text-secondary-600" }
const _hoisted_4 = {
  key: 0,
  class: "ml-2 inline-flex"
}

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'EntryDetailsPanelClose'
},
  __name: 'EntryDetailsPanelClose',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit



const store = useStore()

const isDesktop = computed<boolean>(() => store.getters['app/isLg'])

const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "inline-flex items-center border-0 bg-transparent",
      type: "button",
      "aria-label": _unref(t)('general.close'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
    }, [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_VIcon, {
          icon: isDesktop.value ? '$close' : '$chevron-left',
          size: "small",
          class: "text-secondary-900"
        }, null, 8, ["icon"])
      ]),
      (!isDesktop.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2)
  ]))
}
}

})